import { attendeeFetchData, attendeeDeleteData, attendeeSendData, attendeePutData } from "./index";

const evaluationsAPI = {
    fetch: (attendeeId, sessionId) => attendeeFetchData(`/api/v2/attendees/${attendeeId}/sessions/${sessionId}/evaluation-questions`),
    send: (attendeeId, sessionId, data) => attendeeSendData(`/api/v2/attendees/${attendeeId}/sessions/${sessionId}/evaluation-questions`, data),
}

export default evaluationsAPI;